// The banner that says which mode you are in, and how to leave.
//
// Ships with previewMode.js and is not optional — see the note there.
// Before this, a visitor on a preview link had no indication of it at
// all. Once the mode follows them across the whole site, an invisible
// mode with no exit is a trap.
//
// Fixed to the top of the viewport rather than placed in the page flow:
// it has to be visible on every page including ones that scroll, and
// pages here render their own headers independently. The body padding it
// needs is applied by main.jsx, which is the only place that knows the
// banner is present.
import React from "react";
import { exitPreview } from "./previewMode.js";

// THE SAME WAY ROUND AS THE ADMIN: demo amber, test blue.
//
// These were swapped — test amber, demo blue — the exact opposite of
// MODE_COLOR in AdminApp. Somebody who learns the colours in the admin
// panel and then looks at a preview link was being told the wrong thing
// by the one signal that does not need reading.
//
// Literal values rather than the CSS variables: this banner renders
// before the theme provider on some paths, and a var that resolves to
// nothing would leave it unreadable.
const COLOURS = {
  demo: { bg: "#3d2f00", fg: "#ffd45e", border: "#7a5c00" },
  test: { bg: "#00303d", fg: "#5ed4ff", border: "#005c7a" },
};

export default function PreviewModeBanner({ preview }) {
  if (!preview) return null;
  const c = COLOURS[preview.mode] || COLOURS.test;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: c.bg,
        color: c.fg,
        borderBottom: "1px solid " + c.border,
        padding: "7px 14px",
        fontSize: 13,
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <strong>{preview.label}</strong>
      <span style={{ opacity: 0.85 }}>
        {/* Says what matters to whoever is looking at it, without our
              internal vocabulary. Somebody being shown this by a partner
              needs to know it is not real — otherwise they may believe
              they have entered a competition and won something. */}
          Nothing here is real — the competitions, prizes and payments are all examples.
      </span>
      <button
        type="button"
        onClick={exitPreview}
        style={{
          marginLeft: "auto",
          background: "transparent",
          color: c.fg,
          border: "1px solid " + c.border,
          borderRadius: 6,
          padding: "3px 10px",
          fontSize: 12,
          cursor: "pointer",
        }}
      >
        Leave {preview.mode} mode
      </button>
    </div>
  );
}
